<template>
  <div class="bg-white overflow-hidden py-10">
    <div class="grid *:col-start-1 *:row-start-1 *:items-center">
      <div
        v-for="quote in quotes"
        :key="quote.id"
        class="flex items-center transition-opacity duration-400 ease-in-out"
        :class="quote.id === current.id ? 'opacity-100' : 'opacity-0 pointer-events-none'">
        <div class="w-full page-container">
          <!-- Mobile: always stack logo on top centered, then text below -->
          <div class="flex flex-col items-center gap-3 sm:hidden">
            <img :src="quote.logo" :alt="quote.author" class="h-13 object-contain" />
            <p class="text-gray-500 text-center">"{{ $t(quote.content) }}"</p>
            <p class="text-gray-900 text-center text-sm">
              <span class="font-semibold">{{ quote.author }}</span>
              <span class="mx-1">|</span>
              <span>{{ $t(quote.authorDescription) }}</span>
            </p>
          </div>
          <!-- Desktop: alternating logo left/right -->
          <div class="hidden sm:grid sm:grid-cols-5 items-center">
            <div v-if="quote.id % 2 === 0" class="col-span-1 flex justify-center">
              <img :src="quote.logo" :alt="quote.author" class="w-52 p-10 object-contain" />
            </div>
            <div class="col-span-4">
              <p class="text-md text-gray-500">"{{ $t(quote.content) }}"</p>
              <div class="mt-4">
                <p class="text-gray-900 text-sm">
                  <span class="font-semibold">{{ quote.author }}</span>
                  <span class="mx-1">|</span>
                  <span>{{ $t(quote.authorDescription) }}</span>
                </p>
              </div>
            </div>
            <div v-if="quote.id % 2 !== 0" class="col-span-1 flex justify-center">
              <img :src="quote.logo" :alt="quote.author" class="w-52 p-10 object-contain" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Dots -->
    <div class="flex justify-center gap-2 mt-6">
      <button
        v-for="(q, i) in quotes"
        :key="q.id"
        class="w-2.5 h-2.5 rounded-full transition-colors duration-300"
        :class="i === currentIndex ? 'bg-primary' : 'bg-gray-300'"
        @click="goTo(i)" />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from "vue";
import { quotes } from "./quotes.json";

const currentIndex = ref(0);
const current = computed(() => quotes[currentIndex.value]);

let timer;

const goTo = (i) => {
  currentIndex.value = i;
  resetTimer();
};

const next = () => {
  currentIndex.value = (currentIndex.value + 1) % quotes.length;
};

const resetTimer = () => {
  clearInterval(timer);
  timer = setInterval(next, 10_000);
};

onMounted(() => {
  if (quotes.length > 1) resetTimer();
});

onUnmounted(() => {
  clearInterval(timer);
});
</script>

<style scoped></style>
